// extracted by mini-css-extract-plugin
export default {"div":"NotificationDetailsDialog_div__01Uzf","divError":"NotificationDetailsDialog_divError__+Sj1q"};